import type { IconName } from "@similarweb/icons";

import type { WebSource } from "app/components/filters-bar/websource-filter/WebSourceFilter.types";

export enum EGraphType {
    "overview",
    "stacked-chart",
    "chart-stacked-share",
}

export type GraphType = keyof typeof EGraphType;

export const GRAPH_TYPES: Extract<IconName, GraphType>[] = ["overview", "stacked-chart", "chart-stacked-share"];

type DeviceType = "Mobile" | "Desktop" | "Total";

export const webSourceToDeviceMap: Record<WebSource, DeviceType> = {
    Desktop: "Desktop",
    MobileWeb: "Mobile",
    Total: "Total",
};
